import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import Logo from "../../assets/LogoInsurcloud_NoBackground.png";
import DeloitteLogo from "../../assets/Deloitte_LogoNoBackground.png";
import "./Login.css";

function LoginPage() {
  const { isAuthenticated, loginRedirect } = useAuth();

  if (isAuthenticated) return <Navigate to="/" replace />;

  return (
    <div className="login-page">
      {/* ── Left: Brand panel ── */}
      <div className="login-brand">
        <div className="login-brand__grid" />
        <div className="login-brand__orb login-brand__orb--1" />
        <div className="login-brand__orb login-brand__orb--2" />
        <div className="login-brand__orb login-brand__orb--3" />

        {/* Floating particles */}
        <div className="login-brand__particles">
          {Array.from({ length: 10 }).map((_, i) => (
            <div key={i} className="login-brand__particle" />
          ))}
        </div>

        <div className="login-brand__content">
          <div className="login-brand__logo-chip">
            <img src={Logo} alt="InsurCloud" className="login-brand__ic-logo" />
          </div>
          <h1 className="login-brand__headline">
            Welcome to<br /><strong>IC Control Tower</strong>
          </h1>
          <div className="login-brand__accent" />
          <p className="login-brand__tagline">
            Centralized monitoring and validation platform for insurance operations
          </p>

          <div className="login-brand__features">
            <div className="login-brand__feature">
              <div className="login-brand__feature-icon">
                <i className="bi bi-shield-check" />
              </div>
              <span>Real-time fleet health monitoring</span>
            </div>
            <div className="login-brand__feature">
              <div className="login-brand__feature-icon">
                <i className="bi bi-graph-up-arrow" />
              </div>
              <span>Automated daily validations</span>
            </div>
            <div className="login-brand__feature">
              <div className="login-brand__feature-icon">
                <i className="bi bi-database-check" />
              </div>
              <span>ETL job monitoring &amp; data integrity</span>
            </div>
            <div className="login-brand__feature">
              <div className="login-brand__feature-icon">
                <i className="bi bi-robot" />
              </div>
              <span>AI-powered incident resolution</span>
            </div>
          </div>
        </div>

        {/* Powered by Deloitte footer */}
        <div className="login-brand__powered">
          <span className="login-brand__powered-text">Powered by</span>
          <img src={DeloitteLogo} alt="Deloitte" className="login-brand__powered-logo" />
        </div>
      </div>

      {/* ── Right: Login form ── */}
      <div className="login-form-panel">
        <div className="login-form__wrapper">
          <div className="login-form__platform-badge">InsurCloud Platform</div>

          <h2 className="login-form__title">Sign in</h2>
          <p className="login-form__subtitle">
            Access the Control Tower with your<br />organization credentials
          </p>

          <button className="login-form__button" onClick={loginRedirect}>
            <span>Login</span>
            <i className="bi bi-arrow-right login-form__button-icon" />
          </button>

          <div className="login-form__divider">
            <span>secured by</span>
          </div>

          <div className="login-form__security">
            <i className="bi bi-lock-fill" />
            <span>AWS Cognito &middot; Enterprise SSO Authentication</span>
          </div>
        </div>

        <div className="login-form__footer">
          Copyright &copy; {new Date().getFullYear()} Deloitte Technology SA.<br />
          All rights reserved.
        </div>
      </div>
    </div>
  );
}

export default LoginPage;
